<template>
    <div>
        <gofix-card title=" " classHeader="mb-2" classContent="position-relative">
            <b-row>
                <b-col md="9">
                    <b-row>
                        <b-col md="9">
                            <dropdown-projects
                                required
                                show-icon-required
                                :disabled="Item.status != 'New'"
                                v-model="info.project">
                            </dropdown-projects>
                        </b-col>
                        <b-col md="3">
                            <gofix-form-input 
                                disabled
                                label="Status" 
                                v-model="info.status">
                            </gofix-form-input>
                        </b-col>
                    </b-row>
                    <b-row class="mb-16">
                        <b-col md="4">
                            <gofix-form-input-date
                                :minDate="new Date()"
                                required
                                show-icon-required
                                :disabled="Item.status != 'New'"
                                v-model="info.date"
                                label="Date">
                            </gofix-form-input-date>
                        </b-col>
                        <b-col md="8">
                            <gofix-form-input 
                                label="Venue" 
                                :disabled="Item.status != 'New'"
                                v-model="info.venue">
                            </gofix-form-input>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="12">
                            <gofix-form-dropdown 
                                label="Topics" 
                                vLabel="reference_value_text"
                                required
                                show-icon-required
                                :disabled="Item.status != 'New'"
                                multiple
                                v-model="info.topics" 
                                :options="options.topics">
                            </gofix-form-dropdown>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col md="3" v-if="info && info.id && ['New'].includes(info.status)">
                    <gofix-text-field class="mb-3" label="URL" inputStyle>
                        {{localHref + "/#/briefing-register?briefing_id=" + info.id}}
                    </gofix-text-field>
                    <gofix-text-field label="QR Code" inputStyle>
                        <div class="text-center">
                            <qrcode-vue :value="`${localHref}/#/briefing-register?briefing_id=${info.id}`" :size="130" level="L"></qrcode-vue>
                            <gofix-button label="Download Hi-res QR Image" @click="downloadQRCode" outline></gofix-button>
                        </div>
                    </gofix-text-field>
                </b-col>
            </b-row>
            
        </gofix-card>
        <b-row>
            <b-col md="7">
                <gofix-card title="Basic Info" classContent="position-relative pr-83" style="min-height: 260px;" v-if="info.status && !['New', 'Briefing Completed'].includes(info.status)">
                    <b-row class="mb-16">
                        <b-col md="6">
                            <gofix-text-field class-label="width-165" label="Briefing Completed Date" oneline>{{ info.completed_at ? $options.filters.formatDatebyMoment(info.completed_at, "YYYY-MM-DD","DD.MM.YYYY") : "n/a" }}</gofix-text-field>
                        </b-col>
                        <b-col md="6">
                            <gofix-text-field class-label="width-165" label="Briefing Completed By" oneline>{{ info.completed_by && info.completed_by.name ? info.completed_by.name : '' }}</gofix-text-field>
                        </b-col>
                    </b-row>
                    <b-row class="mb-16">
                        <b-col md="6">
                            <gofix-text-field class-label="width-165" label="Training Accepted Date" oneline>{{ info.accepted_at ? $options.filters.formatDatebyMoment(info.accepted_at, "YYYY-MM-DD","DD.MM.YYYY") : "n/a" }}</gofix-text-field>
                        </b-col>
                        <b-col md="6">
                            <gofix-text-field class-label="width-165" label="Training Accepted By" oneline>{{ info.accepted_by && info.accepted_by.name ? info.accepted_by.name : '' }}</gofix-text-field>
                        </b-col>
                    </b-row>
                    <b-row class="mb-16" v-if="info.status && info.status == 'Started' || info.status == 'Training Completed'">
                        <b-col md="6">
                            <gofix-text-field class-label="width-165" label="Started Date" oneline>{{ info.started_at ? $options.filters.formatDatebyMoment(Item.started_at, "YYYY-MM-DD","DD.MM.YYYY") : "n/a" }}</gofix-text-field>
                        </b-col>
                        <b-col md="6">
                            <gofix-text-field class-label="width-165" label="Started By" oneline>{{ info.started_by && info.started_by.name ? info.started_by.name : '' }}</gofix-text-field>
                        </b-col>
                    </b-row>
                    <b-row v-if="info.status && info.status == 'Training Completed'">
                        <b-col md="6">
                            <gofix-text-field class-label="width-165" label="Training Completed Date" oneline>{{ info.acknowledged_at ? $options.filters.formatDatebyMoment(Item.acknowledged_at, "YYYY-MM-DD","DD.MM.YYYY") : "n/a" }}</gofix-text-field>
                        </b-col>
                        <b-col md="6">
                            <gofix-text-field class-label="width-165" label="Training Completed By" oneline>{{ info.acknowledged_by && info.acknowledged_by.name ? info.acknowledged_by.name : '' }}</gofix-text-field>
                        </b-col>
                    </b-row>
                    <b-row v-if="info.status && info.status == 'Rejected'">
                        <b-col md="6">
                            <gofix-text-field class-label="width-165" label="Rejected Date" oneline>{{ Item.rejected_at ? $options.filters.formatDatebyMoment(Item.rejected_at, "YYYY-MM-DD","DD.MM.YYYY") : "n/a" }}</gofix-text-field>
                        </b-col>
                        <b-col md="6">
                            <gofix-text-field class-label="width-165" label="Rejected By" oneline>{{ Item.rejected_by && Item.rejected_by.name ? Item.rejected_by.name : '' }}</gofix-text-field>
                        </b-col>
                    </b-row>
                </gofix-card>
            </b-col>
            <b-col md="5" class="pl-0">
                <gofix-card title="Training Schedule" classContent="position-relative pr-83"  style="min-height: 260px;" v-if="info.status && !['New', 'Briefing Completed'].includes(info.status)">
                    <template slot="gofixCard:right_header">
                        <template v-if="$checkRole(this.$accessModule.safety_induction_training, 'update') && (info && info.id && info.status == 'Training Accepted')">
                            <button class="icon-button" @click="showModalTraning"><img width="20" src="img/iconPencil.png" alt="" /></button>
                        </template>
                    </template>
                    <b-row>
                            <b-col md="12" class="mb-16">
                                <gofix-text-field class-label="width-70" label="Date" oneline>{{ info.schedule_training_date ? $options.filters.formatDatebyMoment(info.schedule_training_date, "YYYY-MM-DD","DD.MM.YYYY") : "" }}</gofix-text-field>
                            </b-col>
                            <b-col md="12" class="mb-16">
                                <gofix-text-field class-label="width-70" label="Venue" oneline>{{ info.schedule_training_venue }}</gofix-text-field>
                            </b-col>
                            <b-col md="12" class="mb-16">
                                <gofix-text-field class-label="width-70" label="Trade" oneline>{{ info.schedule_training_trade }}</gofix-text-field>
                            </b-col>
                            <b-col md="12">
                                <gofix-text-field class-label="width-70" label="Company" oneline>{{ info.schedule_training_company }}</gofix-text-field>
                            </b-col>
                        </b-row>
                    </gofix-card>
            </b-col>
        </b-row>
        
        <detail-workers></detail-workers>

        <attachment :Item="Item" :attachable_type="'safety_induction_training_documents'" title="Documents" classHeaderCard="pl-4" :isFixed="false"></attachment>

        <gofix-card v-if="info && info.id && ['Training Accepted', 'Started', 'Training Completed'].includes(info.status)" title="Photos" classHeader="mb-2" classContent="position-relative pr-83">
            <b-row align-v="center" class="mt-3">
                <b-col md="12">
                    <p class="mb-2">(Attach Photograph / Drawings)</p>
                    <div>
                        <div v-if="info.photos && info.photos.length" class="photosThumb photosThumb-safety mt-0 mb-0">
                            <viewer-image :images="info.photos">
                                <template slot="gofixViewer:list_image" ref="viewerFinding" slot-scope="{images}">
                                    <ul class="list-thumb">
                                        <template v-for="(item, key) in info.photos">
                                            <li :key="key">
                                                <img v-auth-image="item.url.medium" alt  src="img/loading.gif"/>
                                                <span class="delete" v-if="info && info.id && ['Training Accepted'].includes(info.status)" @click.stop="deleteFile(item)">
                                                    <img src="img/close.png" alt />
                                                </span>
                                            </li>
                                        </template>
                                    </ul>
                                </template>
                            </viewer-image>
                        </div>
                        <div class="upload-btn-wrapper ml-0 mt-0 d-block" v-if="info && info.id && ['Training Accepted', 'Started'].includes(info.status)">
                            <b-form-file id="fileInputMulti" v-model="attachment.files" :plain="true" :multiple="true"></b-form-file>
                            <gofix-button class="icon-svg icon-svg-left mb-2" label="Upload" outline>
                                <template slot="gofix:button:beforeLabel">
                                    <span class="icon mr-2">
                                        <svg width="23" height="19" viewBox="0 0 23 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M11.6537 8.20604C11.6355 8.1827 11.6121 8.16382 11.5855 8.15083C11.5588 8.13785 11.5296 8.1311 11.4999 8.1311C11.4703 8.1311 11.441 8.13785 11.4144 8.15083C11.3877 8.16382 11.3644 8.1827 11.3461 8.20604L8.61175 11.6655C8.58921 11.6943 8.57522 11.7288 8.57139 11.7652C8.56755 11.8016 8.57403 11.8383 8.59007 11.8711C8.60612 11.904 8.63108 11.9317 8.66212 11.951C8.69315 11.9703 8.72899 11.9805 8.76556 11.9805H10.5698V17.8984C10.5698 18.0058 10.6576 18.0937 10.7651 18.0937H12.2299C12.3373 18.0937 12.4252 18.0058 12.4252 17.8984V11.9829H14.2343C14.3979 11.9829 14.4882 11.7949 14.3881 11.668L11.6537 8.20604Z" fill="#F05600" />
                                            <path d="M18.8096 5.95264C17.6914 3.00342 14.8423 0.90625 11.5049 0.90625C8.16748 0.90625 5.31836 3.00098 4.2002 5.9502C2.10791 6.49951 0.5625 8.40625 0.5625 10.6719C0.5625 13.3696 2.74756 15.5547 5.44287 15.5547H6.42188C6.5293 15.5547 6.61719 15.4668 6.61719 15.3594V13.8945C6.61719 13.7871 6.5293 13.6992 6.42188 13.6992H5.44287C4.62012 13.6992 3.84619 13.3721 3.27002 12.7788C2.69629 12.188 2.39111 11.3921 2.41797 10.5669C2.43994 9.92236 2.65967 9.31689 3.05762 8.80664C3.46533 8.28662 4.03662 7.9082 4.67139 7.73975L5.59668 7.49805L5.93604 6.60449C6.146 6.04785 6.43896 5.52783 6.80762 5.05664C7.17156 4.58962 7.60267 4.17908 8.08691 3.83838C9.09033 3.13281 10.272 2.75928 11.5049 2.75928C12.7378 2.75928 13.9194 3.13281 14.9229 3.83838C15.4087 4.18018 15.8384 4.59033 16.2021 5.05664C16.5708 5.52783 16.8638 6.05029 17.0737 6.60449L17.4106 7.49561L18.3335 7.73975C19.6567 8.09619 20.582 9.2998 20.582 10.6719C20.582 11.48 20.2671 12.2417 19.6958 12.813C19.4156 13.0948 19.0823 13.3182 18.7152 13.4703C18.3481 13.6225 17.9545 13.7003 17.5571 13.6992H16.5781C16.4707 13.6992 16.3828 13.7871 16.3828 13.8945V15.3594C16.3828 15.4668 16.4707 15.5547 16.5781 15.5547H17.5571C20.2524 15.5547 22.4375 13.3696 22.4375 10.6719C22.4375 8.40869 20.897 6.5044 18.8096 5.95264Z" fill="#F05600" />
                                        </svg>
                                    </span>
                                </template>
                            </gofix-button>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </gofix-card>

        <b-modal :no-close-on-backdrop="true" id="modal-Create" title="Training Schedule" hide-footer :centered="true" v-model="modals.training.open">
            <b-row>
                <b-col md="12">
                    <gofix-form-input-date
                        :minDate="new Date()"
                        required
                        show-icon-required
                        v-model="modals.training.schedule_training_date"
                        label="Date">
                    </gofix-form-input-date>
                </b-col>
                <b-col md="12">
                    <gofix-form-input 
                        label="Venue" 
                        required
                        show-icon-required
                        v-model="modals.training.schedule_training_venue">
                    </gofix-form-input>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="12">
                    <gofix-form-input 
                        label="Trade" 
                        required
                        show-icon-required
                        v-model="modals.training.schedule_training_trade">
                    </gofix-form-input>
                </b-col>
                <b-col md="12">
                    <gofix-form-input 
                        label="Company" 
                        required
                        show-icon-required
                        v-model="modals.training.schedule_training_company">
                    </gofix-form-input>
                </b-col>
            </b-row>
            <b-button-group class="d-block text-right">
                <gofix-button label="SAVE" @click="saveTraining" :loading="modals.training.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" id="modal-bacsicInfo" title="Basic Info" hide-footer :centered="true" v-model="modals.bacsicInfo.open">
            <b-form class="pb-10">
                <template>
                    <gofix-form-dropdown 
                        label="Status" 
                        vLabel="name" 
                        :filterable="false" 
                        v-model="modals.bacsicInfo.data.status" 
                        :options="jobOptionStatus">
                    </gofix-form-dropdown>
                </template>
                <gofix-form-input-textarea 
                    v-if="modals.bacsicInfo.data.status == 'Rejected'"
                    label="Reason for Rejection"
                    v-model="modals.bacsicInfo.data.reason_reject" 
                    showIconRequired 
                    required>
                </gofix-form-input-textarea>
                <div v-if="['Briefing Completed', 'Training Completed'].includes(modals.bacsicInfo.data.status)">
                    <VueSignaturePad id="signature" width="500px" height="500px" ref="signaturePad" />
                </div>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="APPLY" @click="checkShowPopUpSignature" :loading="modals.bacsicInfo.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';
    import QrcodeVue from 'qrcode.vue'
    const DetailWorkers = () => import("./detail-workers")
    import attachment from '@/views/attachments/safety_list';
    const ViewerImage = () => import('../../plugins/ViewerImage.vue')
    import DropdownProjects from '../elements/DropdownProjects.vue'
    
    export default {
        name: 'safety-inspection-checklist-detail-info',
        components: {
            QrcodeVue,
            DetailWorkers,
            attachment,
            ViewerImage,
            DropdownProjects
        },
        data() {
            return {
                localHref : window.location.origin,
                info: {},
                options: {
                    topics: []
                },
                timer: {
                    save_training: null
                },
                modals: {
                    bacsicInfo: {
                        open: false,
                        loading: false,
                        data: {
                            status: null,
                            reason_reject: null,
                            completed_by_id: null,
                            accepted_by_id: null,
                            started_by_id: null,
                            completed_at: null,
                            completed_at_hour: null,
                            accepted_at: null,
                            accepted_at_hour: null,
                            started_at: null,
                            started_at_hour: null,
                        },
                        options: {
                            fm_users: [],
                            supllier_users: [],
                        }
                    },
                    training: {
                        open: false,
                        loading: false,
                        is_change_status: false,
                        data: {
                            schedule_training_date: null,
                            schedule_training_venue: null,
                            schedule_training_trade: null,
                            schedule_training_company: null
                        },
                    }
                },
                option_status: {
                    'New': ['Briefing Completed'],
                    'Briefing Completed': ['Training Accepted', 'Rejected'],
                    'Training Accepted': ['Started'],                    
                    'Started': ['Training Completed'],                    
                },
                attachment: {
                    items: [],
                    files: [],
                },
            }
        },
        computed: {
            ...mapGetters({
                User : 'AuthController/user',
                Item: 'SafetyAppController/safetyTraining',
            }),
            jobOptionStatus() {
                return this.option_status[this.Item.status];
            },
        },
        watch: {
            Item: function(val) {
                this.setValue();
            },
            "attachment.files": function(val, old) {
                if (val) {
                    // if(val.length > 4 || ((val.length + this.attachment.items.length) > 4)) {
                    //     return this.$alertNotification("Max photos: 4", "danger");
                    // }

                    val.forEach((file) => {
                        if (
                            file.type != "image/jpeg" &&
                            file.type != "image/png" &&
                            file.type != "image/gif"
                        ) {
                            this.$alertNotification("File format is incorrect. Please select a .jpeg, .jpg, .png, .gif file!", "warning");
                            return;
                        }
                        file.moment = moment().valueOf();
                        let data = {
                            moment: moment().valueOf(),
                            url: {
                                original: URL.createObjectURL(file),
                                medium: URL.createObjectURL(file),
                                thumb: URL.createObjectURL(file),
                            }
                        };
                        this.attachment.items.push(file);
                        this.info.photos.push(data);
                    });
                }
                
            },
        },
        created() {
            this.setValue();
            this.getTopics();
        },
        methods: {
            async setValue() {
                if(this.Item && this.Item.id && this.$route.params.id == this.Item.id) {
                    this.info = JSON.parse(JSON.stringify(this.Item))
                    this.info.date = new Date(this.info.date)
                    // callback Contract selector
                    if(this.info && this.info.client_contract_id && (!this.ClientContractID || !this.ClientContractID.id || (this.ClientContractID && this.ClientContractID.id && this.ClientContractID.id != this.info.client_contract_id))) {
                        await this.$store.dispatch( 'ContractController/getClientContractID', this.info.client_contract_id).then(response => {
                            localStorage.setItem("ClientContractID", JSON.stringify(response.data.data));
                        })
                    }
                }
            },
            getTopics(){
                let filter = {reference_type: "Safety Induction Training Topics"};
                let params = {
                    filter: filter,
                    limit: -1,
                    sortColumn: "id",
                    sortDirection: "asc",
                };
                this.$store.dispatch(`ReferenceController/getItems`, params)
                    .then(response => {
                        this.options.topics = response.items;
                    })
            },
            showModalTraning() {
                this.modals.training.data = {
                    schedule_training_date: new Date(this.info.schedule_training_date),
                    schedule_training_venue: this.info.schedule_training_venue,
                    schedule_training_trade: this.info.schedule_training_trade,
                    schedule_training_company: this.info.schedule_training_company,
                }
                this.modals.training.open = true;
            },
            saveTraining() {
                if (this.timer.save_training) {
                    clearTimeout(this.timer.save_training);
                    this.timer.save_training = null;
                }
                this.timer.save_training = setTimeout(() => {
                    const validate_fields = [
                       { key: 'schedule_training_date', name: 'Date'},
                        { key: 'schedule_training_venue', name: 'Venue'},
                        { key: 'schedule_training_trade', name: 'Trade'},
                        { key: 'schedule_training_company', name: 'Company'},
                    ]
                    const is_validate = this.$validationData(validate_fields, this.modals.training)
                    if(is_validate) return

                    this.modals.training.loading = true;
                    let request = {
                        id: this.Item.id,
                        data: {
                            schedule_training_date: moment(this.modals.training.schedule_training_date).format("YYYY-MM-DD"),
                            schedule_training_venue: this.modals.training.schedule_training_venue,
                            schedule_training_trade: this.modals.training.schedule_training_trade,
                            schedule_training_company: this.modals.training.schedule_training_company,
                            is_schedule_training: true
                        }
                    };
                    this.$store
                        .dispatch("SafetyAppController/updateSafetyInductionTrainingItem", request)
                        .then(data => {
                            this.$emit("reloadItem");
                            this.modals.training.loading = this.modals.training.open = false;
                            if(this.modals.training.is_change_status) {
                                this.modals.training.is_change_status = false;
                                this.changeStatus({status: 'Training Accepted'});
                                return;
                            }
                            this.$alertNotification(this.$notificationV2("editing", "safe_induction_training_training"));
                        })
                        .catch((err) => {
                            this.modals.training.loading = false
                            if(err.response.data.error.message){
                                return this.$alertNotification(err.response.data.error.message, "danger");
                            }
                        });
                }, 100);
            },


            /*-- Get Data --------*/
            editBacsicInfo() {
                this.modals.bacsicInfo.data = Object.assign(this.modals.bacsicInfo.data, {
                    status: null,
                    completed_by_id: this.Item.completed_by_id,
                    acknowledged_by_id: this.Item.acknowledged_by_id,
                    submitted_by_id: this.Item.submitted_by_id,
                    submitted_at: this.Item.submitted_at ? new Date(this.Item.submitted_at) : null,
                    submitted_at_hour: this.Item.submitted_at ? moment(new Date(this.Item.submitted_at)).format("HH:mm") : null,
                    acknowledged_at: this.Item.acknowledged_at ? new Date(this.Item.acknowledged_at) : null,
                    acknowledged_at_hour: this.Item.acknowledged_at ? moment(new Date(this.Item.acknowledged_at)).format("HH:mm") : null,
                    completed_at: this.Item.completed_at ? new Date(this.Item.completed_at) : null,
                    completed_at_hour: this.Item.completed_at ? moment(new Date(this.Item.completed_at)).format("HH:mm") : null,
                });
                this.modals.bacsicInfo.open = true;
            },
            checkShowPopUpSignature() {
                this.updateBasicInfo();
            },
            async updateBasicInfo() {
                if(!this.modals.bacsicInfo.data.status) {
                    return this.$alertNotification("Please select status", "danger");
                }

                let file = null;
                if(['Briefing Completed', 'Training Completed'].includes(this.modals.bacsicInfo.data.status)) {
                    if(this.modals.bacsicInfo.data.status == 'Briefing Completed' && this.Item.checked_workers_count == 0) {
                        return this.$alertNotification("Please confirm worker attendance before proceeding.", "danger");
                    }

                    const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
                    if(isEmpty) {
                        return this.$alertNotification("Please sign to continue", "danger");
                    }
                    file = data
                }

                if(this.modals.bacsicInfo.data.status == 'Training Accepted') {
                    this.modals.bacsicInfo.open = false;
                    this.modals.training.is_change_status = true;
                    this.showModalTraning();
                    return;
                }

                if(this.modals.bacsicInfo.data.status == 'Rejected' && !this.modals.bacsicInfo.data.reason_reject) {
                    return this.$alertNotification("Please enter reason for rejection", "danger");
                }
                

                if (this.modals.bacsicInfo.loading) return;
                this.modals.bacsicInfo.loading = true;

                let params = {
                    status: this.modals.bacsicInfo.data.status,
                }

                if(this.modals.bacsicInfo.data.status == 'Rejected') params.reason_reject = this.modals.bacsicInfo.data.reason_reject
                if(['Briefing Completed', 'Training Completed'].includes(this.modals.bacsicInfo.data.status)) {
                    const time = Math.floor((new Date()).getTime() / 1000);
                    const filename = `signature_${time}.png`;
                    const mimeType = "image/png";

                    params.photo_signatures = await this.base64ToFile(file, filename, mimeType)
                }

                this.changeStatus(params);
            },
            changeStatus(params) {
                this.$store
                    .dispatch("SafetyAppController/updateSafetyInductionTrainingStatus", {
                        data: params,
                        id: this.Item.id,
                    })
                    .then((result) => {
                        this.$alertNotification(this.$notificationV2("editing", "safe_induction_training_briefing"));
                        this.modals.bacsicInfo.loading = false;
                        this.modals.bacsicInfo.open = false;
                        this.$emit("reloadItem");
                    })
                    .catch((err) => {
                        this.modals.bacsicInfo.loading = false;
                        if(err.response.data.error.message.error){
                            return this.$alertNotification(err.response.data.error.message.error, "danger");
                        }
                    });
            },
            processJob(data) {
                let status = data.status.toLowerCase();
                if(status == 'training completed') status = 'acknowledged'
                if(status == 'briefing completed') status = 'completed'
                const defaultStatus = {
                    'completed': {
                        status: 'Briefing Completed',
                        completed_by_id: data.completed_by_id || null,
                        completed_at: null,
                    },
                    'accepted': {
                        status: 'Training Accepted',
                        accepted_by_id: data.accepted_by_id || null,
                        accepted_at: null,
                    },
                    'started': {
                        status: 'Started',
                        started_by_id: data.started_by_id || null,
                        started_at: null,
                    },
                    'rejected': {
                        status: 'Rejected',
                        rejected_by_id: data.rejected_by_id || null,
                        rejected_at: null,
                    },
                    'acknowledged': {
                        status: 'Training Completed',
                        acknowledged_by_id: data.acknowledged_by_id || null,
                        acknowledged_at: null,
                    },
                };
                

                const obj = defaultStatus[status];

                if(!obj[`${status}_by_id`]) {
                    this.$alertNotification(`Please select ${obj.status} By`, "danger");
                    return false
                }

                if (data[`${status}_at`]) {
                    obj[`${status}_at`] = moment(new Date(data[`${status}_at`])).format("YYYY-MM-DD");
                }

                if (data[`${status}_at_hour`]) {
                    obj[`${status}_at`] = obj[`${status}_at`] + ' ' + data[`${status}_at_hour`] + ":00";
                }

                return obj
            },
            async base64ToFile(base64String, filename, mimeType) {
                const response = await fetch(base64String);
                const blob = await response.blob();
                return new File([blob], filename, { type: mimeType });
            },
            downloadQRCode() {
                this.$store.dispatch(`SafetyAppController/dowloadQRCodeSafetyInductionTraining`, this.$route.params.id)
                    .then(response => {
                        const link = document.createElement('a');
                        link.href = response;
                        link.setAttribute('download', `QRCode_Briefing_${this.$route.params.id}.png`);
                        document.body.appendChild(link);
                        link.click();
                    })
                    .catch(error => {
                        console.log(error);
                    })
            },
            deleteFile(img) {
                if (img.moment) {
                    this.attachment.items = this.attachment.items.filter(
                        (item) => item.moment != img.moment
                    );
                    this.info.photos = this.info.photos.filter(
                        (item) => item.moment != img.moment
                    );
                } else {
                    this.attachment.items = this.attachment.items.filter(
                        (item) => item.id != img.id
                    );
                    this.$store.dispatch("SafetyAppController/deleteAttachments", {
                        ids: [img.id]
                    }).then(() => {
                        this.$emit("reloadItem");
                    })
                }
            },
        }
    }
</script>
<style lang="scss">
    .flex-105 {
        flex: 0 0 105px;
    }
    #signature {
        border: double 3px transparent;
        border-radius: 5px;
        background-image: linear-gradient(white, white),
            radial-gradient(circle at top left, #4bc5e8, #9f6274);
        background-origin: border-box;
        background-clip: content-box, border-box;
        margin: 0 auto;
    }
</style>